import type { SupportSubcategoryQuestion } from './types';
import { ANNIVERSARY_ORDER_ITEMS, getAnniversaryQuestionIds } from './shirt-anniversary-spec';
import { getShirtQuestionIds } from './shirt-ids';
import { buildShirtSizeIdGroup, makeShirtSizeQuestions } from './shirt-sizes';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const YES_NO_OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
];

export function makeShirtQuestions(prefix: string, subcategoryId: string): SupportSubcategoryQuestion[] {
  const ids = getShirtQuestionIds(prefix);
  const monthlyVisibleWhen = { questionId: ids.monthlyYn, value: 'Yes' };
  const poloVisibleWhen = { questionId: ids.poloYn, value: 'Yes' };
  const tSizes = buildShirtSizeIdGroup(prefix, 't');
  const poloSizes = buildShirtSizeIdGroup(prefix, 'polo');

  const anniversaryQuestions: SupportSubcategoryQuestion[] = [];
  for (const row of ANNIVERSARY_ORDER_ITEMS) {
    const a = getAnniversaryQuestionIds(prefix, row.slug, row.requiresColor);
    const visibleWhen = { questionId: a.yn, value: 'Yes' };
    const ynLabel = `${row.year} Year Anniversary - ${row.product} needed`;
    const sizeLabel = `${row.year} Year (${row.product}) -`;
    anniversaryQuestions.push({
      id: a.yn,
      subcategoryId,
      type: 'select',
      label: ynLabel,
      required: false,
      options: YES_NO_OPTIONS,
    });
    if (row.requiresColor && a.color) {
      anniversaryQuestions.push({
        id: a.color,
        subcategoryId,
        type: 'text',
        label: `${row.year} Year Anniversary - Polo color choice`,
        required: false,
        visibleWhen,
      });
    }
    anniversaryQuestions.push(
      ...makeShirtSizeQuestions(subcategoryId, sizeLabel, buildShirtSizeIdGroup(prefix, row.slug), visibleWhen),
    );
  }

  return [
    {
      id: ids.monthlyYn,
      subcategoryId,
      type: 'select',
      label: 'Monthly shirts needed',
      required: false,
      options: YES_NO_OPTIONS,
    },
    {
      id: ids.month,
      subcategoryId,
      type: 'select',
      label: 'Month',
      required: false,
      options: MONTHS.map((m) => ({ value: m, label: m })),
      visibleWhen: monthlyVisibleWhen,
    },
    ...makeShirtSizeQuestions(subcategoryId, 'T-Shirts quantity', tSizes, monthlyVisibleWhen),
    {
      id: ids.poloYn,
      subcategoryId,
      type: 'select',
      label: 'Polo Shirts needed',
      required: false,
      options: YES_NO_OPTIONS,
    },
    ...makeShirtSizeQuestions(subcategoryId, 'Polo quantity', poloSizes, poloVisibleWhen),
    ...anniversaryQuestions,
  ];
}
